import type { HubspotIntegrationConfiguration } from '@weft/types';
import React from 'react';

type HubspotConfigurationProps = {
  configuration: HubspotIntegrationConfiguration;
};

export const HubspotConfiguration: React.FC<HubspotConfigurationProps> = ({ configuration }) => {
  console.info(configuration);

  return (
    <div className='h-[max(100%,100vh,fit)] min-h-fit bg-[#F6F9FA]'>
      Hubspot Configuration
    </div>
  );
};